import { render } from "./SingleFile.vue?vue&type=template&id=12636a50"
import script from "./SingleFile.vue?vue&type=script&lang=js"
export * from "./SingleFile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__